export const PERMISSIONS = {
  // Login page
  //  - no permissions - always accessible

  // Home page
  // HOME_PAGE_VIEW: 'manuella:home:*/read',

  // Updates
  // UPDATE_VIEW: 'manuella:update:*/read',
  // UPDATE_EDIT: 'manuella:update:*/edit',

  // Tasks
  // TASKS_VIEW: 'manuella:back-office-tasks:*/read',

  // OPERATIONS
  // OPERATION_VIEW: 'manuella:operation:*:position/read',
  // TODO: change this permission...
  OPS_POSITIONS_VIEW: 'manuella:account:*:position:*/read',
  OPS_ACCOUNTS_VIEW: 'manuella:account:*/read',

  // Positions
  POSITION_CREATE: 'manuella:account:*:position/create',
  POSITION_VIEW: 'manuella:account:*:position:*/read',
  POSITION_EDIT: 'manuella:account:*:position:*/edit',
  POSITION_DELETE: 'manuella:account:*:position:*/delete',
  POSITION_HISTORY_LOG_VIEW: 'manuella:account:*:position:*:audit-log/read',

  // Match Details
  MATCH_CREATE: 'manuella:account:*:position:*:match/create',
  MATCH_VIEW: 'manuella:account:*:position:*:match:*/read',
  MATCH_EDIT: 'manuella:account:*:position:*:match:*/edit',
  MATCH_REJECT: 'manuella:account:*:position:*:match:*/reject',
  MATCH_HISTORY_LOG_VIEW: 'manuella:account:*:position:*:match:*:audit-log/read',

  // Talents
  TALENT_CREATE: 'manuella:talent/create',
  TALENT_VIEW: 'manuella:talent:*/read',
  TALENT_EDIT: 'manuella:talent:*/edit',
  TALENT_CONTACT_DETAILS_EDIT: 'manuella:talent:*:contact-details:*/edit',
  TALENT_HISTORY_LOG_VIEW: 'manuella:talent:*:audit-log/read',
  TALENT_CONTACT_DETAILS_CREATE: 'manuella:talent:*:contact-details/create',

  // Engagement
  // ENGAGEMENT_VIEW: 'manuella:account:*:position:*:match:*:engagement:*/read',
  // ENGAGEMENT_CREATE: 'manuella:account:*:position:*:match:*:engagement/create',
  // ENGAGEMENT_RECORD_VIEW: 'manuella:account:*:position:*:match:*:engagement-record:*/read',
  // ENGAGEMENT_RECORD_CREATE: 'manuella:account:*:position:*:match:*:engagement-record/create',

  // Accounts
  ACCOUNT_CREATE: 'manuella:account/create',
  ACCOUNT_VIEW: 'manuella:account:*/read',
  ACCOUNT_EDIT: 'manuella:account:*/edit',
  ACCOUNT_DELETE: 'manuella:account:*/delete',
  ACCOUNT_LOGIN_AS_ADMIN: 'manuella:account:*:user:*/login-as-admin',
  ACCOUNT_PAYMENT_LINK: 'manuella:account:*:payment-link/create',

  // Companies
  COMPANY_VIEW: 'manuella:company:*/read',

  // Match Flow & Candidate Matches
  MATCH_FLOW_VIEW: 'manuella:account:*:position:*:match:*:match-flow:*/read',
  MATCH_FLOW_RUN: 'manuella:account:*:position:*:match:*:match-flow/run',
  MATCH_CANDIDATE_VIEW: 'manuella:account:*:position:*:match:*:match-candidate:*/read',
  MATCH_CANDIDATE_PROMOTE: 'manuella:account:*:position:*:match:*:match-candidate:*/promote',
  MATCH_CANDIDATE_REJECT: 'manuella:account:*:position:*:match:*:match-candidate:*/reject',

  // Sales
  SALES_FLOW: 'manuella:sales-flow/create',

  // Referrals ("Bring a Friend"). Mirrors manuella-gateway's PERMISSIONS.referral, which reuses existing grants.
  REFERRAL_VIEW: 'manuella:account:*/read',
  // Eligibility override / re-check, linking, manual qualify, "paying outside Stripe"
  REFERRAL_EDIT: 'manuella:account-plan:*/edit',
  // Resend / redirect a gift card, end a referral position, tax report
  REFERRAL_MANAGE_REWARDS: 'manuella:account:*/edit',
};

export const PERMISSIONS_GROUPS = {
  POSITION_MATCHES_LIST_PAGE: [
    PERMISSIONS.POSITION_VIEW,
    PERMISSIONS.MATCH_VIEW,
  ],
  POSITION_MATCHES_TAB: [
    PERMISSIONS.MATCH_VIEW,
  ],
};
